export const lucroMessage = `
<strong>Lucro (L)</strong> = Receita Total (RT) - Custo Total (CT)
`;

export const lucratividadeMessage = `
<strong>Lucratividade (%LT)</strong> = Lucro (L) / Receita Total (RT)
`;

export const rentabilidadeMessage = `
<strong>Rentabilidade = Lucro (L)</strong> / Investimento Total (IT)
`;

export const ncgMessage = `
<strong>Necessidade de Capital de Giro</strong> = 
`;

export const nfcgMessage = `
<strong>Necessidade de Formação de Capital de Giro</strong> = Necessidade de Capital de Giro - Capital de Giro Próprio
`;

export const inadimplenciaMessage = `
<strong>Inadimplência (%)</strong> = Quantidade de parcelas em atraso / Quantidade de parcelas vencidas  `;

export const cmlMessage = `
<strong>Comprometimento percentual da Capacidade de Pagamento Mensal Planejada (CML)</strong> = 
Parcelas mensais da dívida ($) / Capacidade Mensal de Pagamento do Planejamento Base. 
`;

export const geeMessage = `
<strong>Grau de Endividamento Econômico (GEE)</strong> = Dívida Total / Receita Anual 
`;
